import { EffectCallback, useEffect } from 'react';

// taken from https://github.com/streamich/react-use/blob/master/src/useEffectOnce.ts
const useEffectOnce = (effect: EffectCallback): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};

export default useEffectOnce;
